import { useId } from 'react';
import { cn } from '../../lib/cn';

export function Slider({
  className,
  value = 0,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  disabled,
  label,
  description,
  marks,
  formatValue = (v) => v,
  ...props
}) {
  const id = useId();
  const percent = ((value - min) / (max - min)) * 100;

  return (
    <div className={cn('w-full', className)}>
      {(label || description) && (
        <div className="mb-3 flex items-end justify-between gap-3">
          <div className="flex flex-col gap-0.5">
            {label && (
              <span
                className="text-[11px] font-medium uppercase tracking-[0.12em]"
                style={{ color: 'var(--dash-text-soft)' }}
              >
                {label}
              </span>
            )}
            {description && (
              <span
                className="text-[11px]"
                style={{ color: 'var(--dash-text-faint)' }}
              >
                {description}
              </span>
            )}
          </div>
          <span
            className="rounded-lg px-2.5 py-1 font-mono text-xs tabular-nums"
            style={{
              background: 'var(--dash-primary-soft)',
              color: 'var(--dash-primary)',
              border: '1px solid var(--dash-primary-border)',
            }}
          >
            {formatValue(value)}
          </span>
        </div>
      )}
      <div className="relative h-9 w-full">
        <div
          className="absolute left-0 right-0 top-1/2 h-1.5 -translate-y-1/2 rounded-full"
          style={{ background: 'var(--dash-surface-hover)' }}
        />
        <div
          className="absolute left-0 top-1/2 h-1.5 -translate-y-1/2 rounded-full"
          style={{
            width: `${percent}%`,
            background: 'linear-gradient(90deg, #ad34fe 0%, #be5bff 100%)',
            boxShadow: '0 0 12px rgba(173,52,254,0.4)',
          }}
        />
        <input
          id={id}
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          disabled={disabled}
          onChange={(e) => onChange?.(Number(e.target.value))}
          className="slider-input absolute inset-0 w-full cursor-pointer appearance-none bg-transparent"
          style={{ WebkitAppearance: 'none' }}
          {...props}
        />
      </div>
      {marks && (
        <div className="mt-1.5 flex justify-between px-1">
          {marks.map((m) => (
            <span
              key={m.value}
              className="text-[10px]"
              style={{ color: 'var(--dash-text-faint)' }}
            >
              {m.label}
            </span>
          ))}
        </div>
      )}
      <style>{`
        .slider-input::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 18px;
          height: 18px;
          border-radius: 9999px;
          background: #fff;
          border: 2px solid #ad34fe;
          box-shadow: 0 0 0 4px rgba(173,52,254,0.18), 0 2px 6px rgba(0,0,0,0.25);
          cursor: pointer;
          transition: transform 0.15s ease;
        }
        .slider-input::-webkit-slider-thumb:hover {
          transform: scale(1.15);
        }
        .slider-input::-moz-range-thumb {
          width: 18px;
          height: 18px;
          border-radius: 9999px;
          background: #fff;
          border: 2px solid #ad34fe;
          box-shadow: 0 0 0 4px rgba(173,52,254,0.18), 0 2px 6px rgba(0,0,0,0.25);
          cursor: pointer;
        }
      `}</style>
    </div>
  );
}
